import React from "react";
import {Container, Image, Section} from "../../../components";
import interactionWithLaw from 'assets/images/interaction-with-law.svg';
import interactionWithConomica from 'assets/images/interaction-with-conomica.svg';
import interactionWithConomicaMobile from 'assets/images/interaction-with-conomica-mobile.svg';
import interactionWithLawMobile from 'assets/images/interaction-with-law-mobile.svg';

import styles from "./HowItWorks.module.scss";
import {useWindowWidth} from "../../../components/pages/detailed-project/hooks";

const HowItWorks = () => {
  const isMobile = useWindowWidth();
  return (
    <div className={styles.howItWorks}>
      <Section className={styles.heroSection}>
        <Container>
          <div className={styles.heroGrid}>
            <div className={styles.heroContent}>
              <h1 className={styles.heroTitle}>
                Платформа Кономика-займы
                {" "}это инструмент инвестирования в инновационный для рынка продукт —{" "}
                займы, обеспеченные залогом дебиторской задолжености.
              </h1>
              <p className={styles.heroDescription}>
                Платформа позволяет частным инвесторам заключать инвестиционные сделки, обеспечением в которых выступают текущие требования заёмщика к своим контрагентам.
              </p>
            </div>
            
            <div className={styles.heroSidebar}>
              <ul className={styles.featureList}>
                <li>
                  Платформа предоставляет услуги по заключению сделок инвестирования в рамках 259 ФЗ  и состоит в реестре Операторов инвестиционных платформ Банка России.
                </li>
                <li>
                  Заемщиками могут выступать исключительно юридические лица в статусе ООО и/или АО.
                </li>
                <li>
                  Сделки осуществляются по принципу коллективного софинансирования – множество инвесторов выступают в качестве инвесторов для заёмщика.
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </Section>
      
      <Section className={styles.platformSection}>
        <Container>
          <div className={styles.platformContent}>
            <h2 className={styles.platformTitle}>Платформа Кономика-займы:</h2>
            <ul className={styles.platformList}>
              <li>
                берёт на себя весь цикл взыскания, в случае просрочки исполнения обязательств со стороны заёмщика, включая обращение требования к предмету залога (обеспечения)
              </li>
              <li>
                информация о сделках, размещенная на платформе, не является публичной офертой и адресована лицам, зарегистрированным на Платформе
              </li>
              <li>не является стороной сделки займа</li>
              <li>не привлекает инвестиционные средства в собственный капитал</li>
              <li>
                предоставляет исключительно техническое решение для прямого взаимодействия инвестора и заёмщика
              </li>
            </ul>
          </div>
          
          <div className={styles.interactionSection}>
            <Image src={isMobile? interactionWithLawMobile :interactionWithLaw} alt={''} className={styles.interactionImage}/>
          </div>
        </Container>
      </Section>
      
      <Section className={styles.legalSection}>
        <Container>
          <div className={styles.legalContent}>
            <span className={styles.legalBadge}>
              Правовая надстройка, используемая на нашей платформе
            </span>
            <h2 className={styles.legalTitle}>
              Команда платформы, используя весь накопленный опыт группы компании 
              Conomica, внедрила механизм, целью которого является сделать инвестирование 
              в рамках 259 ФЗ безопаснее и надежнее.
            </h2>
            <p className={styles.legalDescription}>
              Дополнительно к стандартному механизму инвестирования (в рамках 259 ФЗ) 
              специалистами Conomica создана правовая надстройка, согласно которой в 
              качестве обеспечения исполнения своих обязательств по возврату займа заёмщик 
              предоставляет в залог принадлежащие ему права требования к своим 
              контрагентам (текущая дебиторская задолженность заёмщика).
            </p>
          </div>
        </Container>
      </Section>
      
      <Section className={styles.interactionWithConomicaSection}>
        <Container>
          <Image src={isMobile? interactionWithConomicaMobile:interactionWithConomica} alt={''} className={styles.interactionImage}/>
        </Container>
      </Section>

      <Section className={styles.underwritingSection}>
        <Container>
          <span className={styles.sectionBadge}>андеррайтинг</span>
          
          <div className={styles.underwritingGrid}>
            <div className={styles.underwritingLeft}>
              <p className={styles.rescoreText}>
                Rescore — автоматическая система проверки контрагентов по более 30 источникам. 
                Входит в группу компаний Conomica
              </p>
            </div>
            
            <div className={styles.underwritingCenter}>
              <div className={styles.greenCard}>
                <p>
                  При проведении трехуровневого андеррайтинга и мониторинга текущей 
                  платежеспособности применяются технические решения компании Rescore
                </p>
              </div>
            </div>
            
            <div className={styles.underwritingRight}>
              <div className={styles.stepItem}>
                <span className={styles.stepNumber}>1</span>
                <p>Оценка платежеспособности заемщика</p>
              </div>
              <div className={styles.stepItem}>
                <span className={styles.stepNumber}>2</span>
                <p>Оценка платежеспособности контрагентов</p>
              </div>
              <div className={styles.stepItem}>
                <span className={styles.stepNumber}>3</span>
                <p>Проверка правовой устойчивости прав требования, выступающих в качестве обеспечения</p>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <Section className={styles.safetySection}>
        <Container>
          <span className={styles.sectionBadge}>Безопасность средств</span>
          
          <div className={styles.safetyGrid}>
            <div className={styles.safetyCard}>
              <div className={styles.checkIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="white"/>
                </svg>
              </div>
              <h3 className={styles.safetyTitle}>Номинальный счет в банке Точка</h3>
              <p className={styles.safetyText}>
                Номинальный счет - особая категория счетов, применяемая для хранения средств, 
                права на которые принадлежат третьим лицам.
              </p>
              <p className={styles.safetyText}>
                Для любых платежей, связанных со сделками своих клиентов, Кономика использует 
                номинальный счёт, открытый в рамках 259 ФЗ
              </p>
            </div>
            
            <div className={styles.safetyCard}>
              <div className={styles.checkIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="white"/>
                </svg>
              </div>
              <h3 className={styles.safetyTitle}>Надежный контроль денежных средств</h3>
              <p className={styles.safetyText}>
                Использование номинальных счетов находится под особым банковским контролем. 
                Дополнительно программный комплекс платформы ведет отдельный учет по каждой 
                сделке создавая виртуальные субсчета.
              </p>
              <p className={styles.safetyText}>
                При возврате средств по займу за счет платежа от контрагента средства так же 
                поступают напрямую на номинальный счет и распределяются между инвесторами.
              </p>
            </div>
          </div>
        </Container>
      </Section>

      <Section className={styles.gettingStartedSection}>
        <Container>
          <span className={styles.sectionBadge}>Начало работы на платформе</span>
          
          <div className={styles.stepsContainer}>
            <div className={styles.stepBlock}>
              <div className={styles.stepHeader}>
                <span className={styles.stepBadge}>1</span>
                <h3 className={styles.stepTitle}>Регистрация</h3>
              </div>
              <p className={styles.stepDescription}>
                Регистрация на платформе занимает пару минут: вам необходимо создать пару логин-пароль 
                для создания личного кабинета.
              </p>
            </div>
            
            <div className={`${styles.stepBlock} ${styles.stepBlockCenter}`}>
              <div className={styles.stepHeader}>
                <span className={styles.stepBadge}>2</span>
                <h3 className={styles.stepTitle}>Верификация</h3>
              </div>
              <p className={styles.stepDescription}>
                Для получения доступа к полному функционалу платформы инвестору, и заемщику 
                необходимо пройти верификацию в электронном режиме.
              </p>
            </div>
            
            <div className={styles.stepBlock}>
              <div className={styles.stepHeader}>
                <span className={styles.stepBadge}>3</span>
                <h3 className={styles.stepTitle}>Заключение сделки</h3>
              </div>
              <p className={styles.stepDescription}>
                Заключение сделок на платформе происходит с использованием внутренней ЭЦП
              </p>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default HowItWorks;
